import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ProfilesTab } from '../../../../components/profiles';
import { usePlatformAdmin } from '../../../../hooks';

export const Route = createFileRoute('/projects/$projectId/profiles/')({
  component: ProfilesTabRoute,
});

function ProfilesTabRoute() {
  const { projectId } = useParams({ from: '/projects/$projectId/profiles/' });
  const navigate = useNavigate();
  const { isPlatformAdmin } = usePlatformAdmin();

  useEffect(() => {
    if (!isPlatformAdmin) {
      navigate({ to: '/projects/$projectId/applications', params: { projectId } });
    }
  }, [isPlatformAdmin, navigate, projectId]);

  if (!isPlatformAdmin) return null;

  return <ProfilesTab projectId={projectId} />;
}
